<a
  [routerLink]="'/kb/item/' + hxid"
  class="card card-borderless bg-green-30 full-width"
  style="border-radius: 10px"
>
  <img
    [src]="image"
    [alt]="image"
    class="card-background card-background-right"
  />
  <div
    class="card-body mr-112 col-space-between grid grid-column justify-content-between"
    style="padding: 20px 24px"
  >
    <div
      class="typography typography-headline typography-paragraph typography-medium grey-800"
    >
      Подробное описание
    </div>

    <div class="row-nowrap grid grid-gutter-12 grid-nowrap align-items-center">
      <div class="hidden-sm grid-item">
        <div class="typography typography-caption grey-800">Helixbook</div>
      </div>

      <div class="hidden block-sm grid-item">
        <div class="typography typography-body grey-800">Helixbook</div>
      </div>

      <div class="grid-item">
        <div class="icon icon-arrow-right-3 icon-20 block"></div>
      </div>
    </div>
  </div>
</a>
